<template>
    <div @click="handleLike" class="cursor-pointer">
        <img v-if="!isLiked" src="@/assets/icons/unfavorite.svg" alt="Unfavorite" class="w-4 mr-1" />
        <img v-else src="@/assets/icons/favorite.svg" alt="Favorite" class="w-4 mr-1" />
    </div>
</template>

<script setup>
import {useAuth} from "@/stores/AuthStore";
import {storeToRefs} from "pinia";
import {useResources} from "@/composables/useResources";

const {like, unlike} = useResources()
const {organization} = storeToRefs(useAuth());

const emit = defineEmits(['toggle-like'])

const props = defineProps({
    resourceUid: {
        type: String,
        required: true,
    },
    isLiked: {
        type: Boolean,
        default: false,
        required: true,
    },
})

function handleLike() {
    if(props.isLiked) {
        unlike(organization.value.slug, props.resourceUid)
    } else {
        like(organization.value.slug, props.resourceUid)
    }

    emit('toggle-like')
}
</script>